/** The recording clock: it counts only the time spent recording, so a pause holds it and the limit ignores the wait. */
export interface Clock {
  /** Milliseconds recorded before the current run. */
  before: number;
  /** When the current run began, or null while paused. */
  since: number | null;
}

export const startClock = (now: number): Clock => ({ before: 0, since: now });

export const recordedMs = (c: Clock, now: number): number => c.before + (c.since === null ? 0 : now - c.since);

export const pauseClock = (c: Clock, now: number): Clock => ({ before: recordedMs(c, now), since: null });

export const resumeClock = (c: Clock, now: number): Clock => (c.since === null ? { ...c, since: now } : c);

export const recordedSeconds = (c: Clock, now: number): number => Math.floor(recordedMs(c, now) / 1000);

export const atLimit = (c: Clock, now: number, limitSec: number): boolean => recordedMs(c, now) >= limitSec * 1000;
